<template>
  <div class="header-container">
    <div @click="retrunHome"
         class="return-text">九方气象可视化开发文档（测试版）</div>

    <div class="menu">
      <div class="switch-buttom"
           @change="changeCheck">
        <input class="ios-switch"
               type="checkbox"
               v-model="isCheck">
      </div>
      <el-menu :default-active="$route.path"
               class="el-menu-demo"
               mode="horizontal"
               background-color="transparent"
               text-color="#fff"
               active-text-color="#ffd04b"
               @select="handleSelect"
               router>
        <el-menu-item v-for="(item,index) in menuData"
                      :key="index"
                      :index="item.url">{{item.name}}</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isCheck: false, //是否选中背景切换
      menuData: [
        { label: "docs", name: "开发指南", url: "/sdk/docs" },
        { label: "example", name: "示例", url: "/sdk/example" },
        { label: "api", name: "API", url: "/sdk/api" },
        { label: "code", name: "代码", url: "/sdk/code" },
      ], //菜单栏选项
      activeIndex: "", //路径切换前缀
    };
  },
  watch: {
    activeIndex(newValue, oldValue) {
      console.log(newValue, "<<<<<");
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.activeIndex = key;
      // if (key == "/") {
      //   window.location.href = "/api/index.html";
      // }
    },
    retrunHome() {
      this.activeIndex = "";
      this.$emit("changePath", "sdk/docs");
    },
    changeCheck() {
      this.$emit("changeColor", this.isCheck);
    },
  },
};
</script>
<style lang="scss" scoped>
.return-text {
  // width: 20%;
  cursor: pointer;
  font-size: 25px;
  font-weight: 700;
  color: #fff;
  margin-left: 30px;
}
.menu {
  display: flex;
  .switch-buttom {
    display: flex;
    align-items: center;
  }
}
.btn {
  border-radius: 15px;
  width: 50px;
  height: 30px;
  background-color: #e9e9eb;
}
.ios-switch {
  position: relative;
  appearance: none;
  cursor: pointer;
  transition: all 100ms;
  @extend .btn;
  &::before {
    position: absolute;
    content: "";
    transition: all 300ms cubic-bezier(0.45, 1, 0.4, 1);
    @extend .btn;
  }
  &::after {
    position: absolute;
    left: 4px;
    top: 5px;
    border-radius: 10px;
    width: 20px;
    height: 20px;
    background-color: #fff;
    box-shadow: 1px 1px 5px rgba(#000, 0.3);
    content: "";
    transition: all 300ms cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }
  &:checked {
    background-color: #c3abf2;
    &::before {
      transform: scale(0);
    }
    &::after {
      transform: translateX(23px);
    }
  }
}
.header-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  box-shadow: rgb(22 89 185) 0px 0px 12px;
  background: linear-gradient(135deg, #2d2d6d, #005197, #0677ec, #ce76ab) left
    center/400% 400%;
  // background: linear-gradient(135deg, #f66, #f90, #3c9, #09f, #66f) left
  //   center/400% 400%;
  font-weight: bold;
  font-size: 100px;
  color: #fff;
  animation: move 10s infinite;
}
@keyframes move {
  0%,
  100% {
    background-position-x: left;
  }
  50% {
    background-position-x: right;
  }
}
::v-deep .el-menu-demo {
  //父级的类名
  .el-submenu__title:hover {
    background-color: transparent !important;
    content: "";
  }
  //子级的类名
  .el-menu-item {
    margin: 5px;
    height: 30px;
    line-height: 30px;
    font-size: 17px;
    z-index: 200;
    transition: all 300ms;
    background-color: transparent !important;
    border-bottom: 2px solid transparent;
    &::before {
      position: absolute;
      left: 100%;
      top: 0;
      border-bottom: 2px solid transparent;
      width: 0;
      height: 100%;
      content: "";
      transition: all 300ms;
    }
    // &:active {
    //   background-color: #00c9ff;
    //   color: #fff;
    // }
    &:hover {
      &::before {
        left: 0;
        top: 0;
        z-index: -1;
        border-bottom-color: #00c9ff;
        width: 100%;
        transition-delay: 100ms;
      }
      & + li::before {
        left: 0;
      }
    }
  }
}
::v-deep.el-menu.el-menu--horizontal,
.el-menu-item {
  border: 0px !important;
}
</style>